var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_8041960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03964 4.21214C6.76016 4.05202 7.61828 4 8.61067 4H10.0486C10.9402 4 11.7728 4.4456 12.2674 5.18747L12.9896 6.27084C13.1545 6.51812 13.432 6.66667 13.7292 6.66667H18.2229C19.6429 6.66667 20.7939 7.78769 20.7804 9.23129C20.7642 10.9504 20.7778 12.6701 20.7778 14.3893C20.7778 15.3817 20.7258 16.2398 20.5656 16.9604C20.4033 17.691 20.1181 18.3334 19.6147 18.8369C19.1112 19.3404 18.4688 19.6255 17.7381 19.7878C17.0176 19.948 16.1595 20 15.1671 20H8.61067C7.61828 20 6.76016 19.948 6.03964 19.7878C5.30901 19.6255 4.66656 19.3404 4.16309 18.8369C3.65964 18.3334 3.37452 17.691 3.21214 16.9604C3.05202 16.2398 3 15.3817 3 14.3893V9.61067C3 8.61828 3.05202 7.76016 3.21214 7.03964C3.37452 6.30901 3.65964 5.66656 4.16309 5.16309C4.66656 4.65964 5.30901 4.37452 6.03964 4.21214ZM12.7778 11.1111C12.7778 10.6202 12.3798 10.2222 11.8889 10.2222C11.398 10.2222 11 10.6202 11 11.1111V13.854L10.2952 13.1492C9.94807 12.8021 9.38526 12.8021 9.03812 13.1492C8.691 13.4964 8.691 14.0592 9.03812 14.4063L11.2048 16.573C11.2143 16.5825 11.224 16.5918 11.2339 16.6009C11.3964 16.7779 11.6296 16.8889 11.8889 16.8889C12.1482 16.8889 12.3814 16.7779 12.5439 16.6009C12.5538 16.5918 12.5635 16.5825 12.573 16.573L14.7396 14.4063C15.0868 14.0592 15.0868 13.4964 14.7396 13.1492C14.3925 12.8021 13.8297 12.8021 13.4826 13.1492L12.7778 13.854V11.1111Z",
    fill: "#A92904"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download-file.8367ff7c9380226e4f98b9b0cd186c10.svg";
export { ForwardRef as ReactComponent };